<template>
  <section class="content">
    <admin-header
      :title="'Exchange rate histories'"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      :disableQuickSearch="true"
      :showNewButton="false"      
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminExchangeRateHistory',
    data () {
      return {
        newEntityScreen: 'Admin - Exchange Rate Histories',
        searchEntityScreen: 'Admin - Exchange Rate History search',
        filterEventName: 'admin-exchange-rate-history-filter',
        filterName: 'ExchangeRateHistoryFilter',
        entityName: 'exchange-rate-history'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminExchangeRateHistory.vue?229e3166